import(/* webpackMode: "eager" */ "/var/www/Ligobox/vitrine_ligobox/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Ligobox/vitrine_ligobox/components/CookieConsent.jsx");
